import { toast } from "react-toastify";
import { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";

import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import Modal from "../modal/Modal";
import { Badge } from "primereact/badge";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useAppContext } from "../../context/AppContext";
import { useState } from "react";
import { Dialog } from "primereact/dialog";
import * as XLSX from "xlsx";
import { deleteSchedules } from "../../services/GlobalRoles/deleteSchedules";

const NotificationSchedule = ({ isLoading, isVisible, setIsVisible, selectedSchedule, refetch, requireDownload = false, setRequireDownload }) => {
    const { nomenclatures } = useAppContext();
    const nomenclature = JSON.parse(nomenclatures);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isDisable, setIsDisable] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [currentErrors, setCurrentErrors] = useState([]);
    const [send, setSend] = useState("");

    const groupedData = {
        readjustSale: [],
        others: [],
    };

    selectedSchedule?.forEach((schedule) => {
        if (schedule.type === "readjust_sale") {
            groupedData.readjustSale.push(schedule);
        } else {
            groupedData.others.push(schedule);
        }
    });

    const getBadgeSeverity = (individualItems = []) => {
        const validItems = individualItems.filter((item) => item && typeof item.status !== 'undefined');

        const allStatuses = [...new Set(validItems.map((item) => item.status))];

        if (allStatuses.length === 1) {
            switch (allStatuses[0]) {
                case 1:
                case 2:
                    return "warning";
                case 3:
                    return "success";
                case 4:
                    return "danger";
                default:
                    return "warning";
            }
        } else if (allStatuses.length === 2) {
            return "warning";
        } else {
            return "info";
        }
    };


    function getErrorsByCode(item, code) {
        let errors = [];

        const { obs_error, row_summary } = item;

        if (obs_error) {
            errors.push({
                line: (row_summary || "?").replace(/,/g, "|"),
                key: "error",
                message: obs_error,
            });
        }

        setSend(code);
        return errors;
    }






    function generateExcelReport(errors) {
        const worksheetData = [["Linha", "Descrição"]];

        errors.forEach((error) => {
            const lines = error.line.split("|");
            lines.forEach((line) => {
                worksheetData.push([line.trim(), error.message]);
            });
        });

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Erros");
        XLSX.writeFile(workbook, "relatorio_erros.xlsx");
    }


    const handleBadgeClick = (rowData, code) => {
        const errors = getErrorsByCode(rowData, code);
        setCurrentErrors(errors);

        if (errors.length > 0) {
            const errorMessage = errors
                .map((error) => `Linha(s) ${error.line}: ${error.message}`)
                .join("\n");
            setErrorMessage(errorMessage);
        } else {
            setErrorMessage("Nenhum erro encontrado.");
        }
        setIsModalVisible(true);
    };

    const handleDownload = async () => {
        setIsDisable(true);
        // console.log(selectedSchedule)
        generateExcelReport(currentErrors);
        const code = send;
        await deleteSchedules(code);
        refetch?.();
        setRequireDownload?.(false);
        setIsDisable(false);
        setIsModalVisible(false);
    };
    useEffect(() => {
        async function deleteSuccessfulSchedules() {
            if (!selectedSchedule || selectedSchedule.length === 0) return;

            // Agrupa todos os códigos dos schedules com status 3
            const successfulCodes = selectedSchedule
                .filter((schedule) => schedule.status === 3)
                .map((schedule) => schedule.code);

            if (successfulCodes.length > 0) {
                try {
                    // Deleta todos em paralelo
                    await Promise.all(successfulCodes.map(code => deleteSchedules(code)));

                    // Atualiza os dados após a exclusão
                    refetch?.();
                } catch (error) {
                    console.error("Erro ao excluir schedules com status 3:", error);

                }
            }
        }

        deleteSuccessfulSchedules();
    }, [selectedSchedule]);

    return (
        <>
            <Modal dynamicTitle={"Notificações"} visible={isVisible}
                onHide={() => {
                    if (!requireDownload) {
                        setIsVisible(false)
                    } else {
                        toast.error("Você precisa fazer o download antes de fechar.");
                    }
                }}>
                {isLoading ? (
                    <Skeleton width="100%" height={300} />
                ) : (
                    <>
                        {selectedSchedule && selectedSchedule.length > 0 ? (
                            <>
                                {groupedData?.others.length > 0 && (
                                    <Accordion className="w-100 custom-accordion accordion-notification">
                                        <AccordionTab
                                            header={
                                                <div className="d-flex align-items-center gap-2 w-full">
                                                    <span className="w-100 flex-grow-1">Planilhas de Importação</span>
                                                    <Badge
                                                        value={groupedData.others.length}

                                                        severity={getBadgeSeverity(groupedData.others.flatMap((schedule) => schedule.individual))}
                                                        className="ml-auto"
                                                    />
                                                </div>
                                            }
                                        >
                                            <DataTable value={groupedData.others.flatMap((schedule) => schedule)}>
                                                <Column
                                                    field="type"
                                                    header="Tipo"
                                                    body={(rowData) => {
                                                        switch (rowData.type) {
                                                            case "excel_register_general":
                                                                return "Planilha de Cadastros";
                                                            case "excel_sale":
                                                                return "Planilha de Contratos";
                                                            case "excel_installments":
                                                                return "Planilha de Parcelas";
                                                            case "excel_cost_center":
                                                                return "Planilha de Centro de Custos";
                                                            case "excel_lands":
                                                                return `Planilhas de Cadastros de ${nomenclature[1].value}`;
                                                            case "excel_lands_update":
                                                                return `Planilhas de Atualização de ${nomenclature[1].value}`;
                                                            default:
                                                                return "";
                                                        }
                                                    }}
                                                />
                                                <Column
                                                    field="status"
                                                    header="Status"
                                                    body={(rowData) => {
                                                        switch (rowData.status) {
                                                            case 1:
                                                                return <span className="badge bg-warning">Pendente</span>;
                                                            case 2:
                                                                return <span className="badge bg-warning">Progressando</span>;
                                                            case 3:
                                                                return <span className="badge bg-success">Sucesso</span>;
                                                            case 4:
                                                                return (
                                                                    <span
                                                                        id={`error-badge-${rowData.code}`}
                                                                        className="badge bg-danger"
                                                                        onClick={() => handleBadgeClick(rowData, rowData.code)}
                                                                        style={{ cursor: "help" }}
                                                                    >
                                                                        Erro
                                                                    </span>
                                                                );
                                                            default:
                                                                return <span className="badge bg-warning">Pendente</span>;
                                                        }
                                                    }}
                                                />
                                            </DataTable>
                                        </AccordionTab>
                                    </Accordion>
                                )}
                            </>
                        ) : (
                            <p className="text-center mt-3">Sem notificações no momento.</p>
                        )}
                    </>
                )}
            </Modal>

            <Dialog
                header="Alguns dados não foram importados!"
                visible={isModalVisible}
                style={{ width: "50vw" }}
                onHide={() => {
                    if (!requireDownload) {
                        setIsModalVisible(false);
                        setIsDisable(false);
                    } else {
                        toast.error("Você precisa fazer o download antes de fechar.");
                    }
                }}
                footer={
                    <div>
                        <button onClick={handleDownload} disabled={isDisable} className="p-button p-component">
                            Fazer Download
                        </button>
                    </div>
                }
            >
                <pre>{errorMessage}</pre>
            </Dialog>
        </>
    );
};

export default NotificationSchedule;
